import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { jqxMenuComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxmenu';

@Component({
  selector: 'app-gotx-menu',
  templateUrl: './gotx-menu.component.html',
  styleUrls: ['./gotx-menu.component.css']
})
export class GotxMenuComponent implements OnInit {
  @ViewChild('gotxMenu', { static: false }) gotxMenu: jqxMenuComponent;
  @Output() selectedCntxtMenu = new EventEmitter<String>();

  width: number = 130;
  height: number = 200;

  constructor() { }

  ngOnInit() {

    // setTimeout(() => {
    //   // this.gotxMenu.open(100,300);
    // }, 3000);
  }

  isRightClick(event: any): boolean {
    let rightclick;
    if (!event) event = window.event;
    if (event.which) rightclick = (event.which == 3);
    else if (event.button) rightclick = (event.button == 2);
    return rightclick;
  }

  contextmenuMenu(): boolean {
    return false;
  }

  showOptionChain = true;

  mousedown(event: any): boolean {
    var scrollTop = window.scrollY
    var scrollLeft = window.scrollX
    var xOffset = 0;
    var yOffset = 0;
    // var menuWidth = this.width;
    // var menuHeight = this.height;
    var windowWidth = window.innerWidth
    var windowHeight = window.innerHeight
    var eventX = parseInt(event.clientX);
    var eventY = parseInt(event.clientY);
    if (eventX + this.width > windowWidth) {
      xOffset = this.width;
    };
    if (eventY + this.height > windowHeight) {
      yOffset = this.height;
    };

    let rightClick = this.isRightClick(event) || jqx.mobile.isTouchDevice();
    if (rightClick) {

      //this.gotxMenu.open(parseInt(event.clientX), parseInt(event.clientY));
      this.gotxMenu.open(eventX + 5 + scrollLeft - xOffset, eventY + 5 + scrollTop - yOffset);

      return false;
    }
  }

  onMenuClick(menu: string) {
    this.selectedCntxtMenu.emit(menu);
  }

}
